var map = {
	"./Group 22302.png": 1356,
	"./avatar-christmas.webp": 1357,
	"./bottom-bg-christmas.webp": 1358,
	"./btn-active.png": 1359,
	"./content-deco-1.webp": 1360,
	"./content-deco-2.webp": 1361,
	"./content-deco-3.webp": 1362,
	"./content-deco-4.webp": 1363,
	"./deco-3.webp": 1364,
	"./deposit-icon.webp": 1365,
	"./home-icon-active.webp": 1366,
	"./home-icon.webp": 1367,
	"./live-icon-active.webp": 1368,
	"./live-icon.webp": 1369,
	"./master-bg.jpg": 1370,
	"./master-bg.webp": 1371,
	"./me-icon-active.webp": 1372,
	"./me-icon.webp": 1373,
	"./platform.png": 1374,
	"./platform.webp": 1375,
	"./promos-icon-active.webp": 1376,
	"./promos-icon.webp": 1377,
	"./promos.webp": 1378,
	"./service-christmas.webp": 1379,
	"./snowman.webp": 1380,
	"./sponsor-icon-active.webp": 1381,
	"./sponsor-icon.webp": 1382,
	"./title-deco-left.webp": 1383,
	"./title-deco-right.webp": 1384,
	"./tree.webp": 1385,
	"./vip-icon.webp": 1386,
	"./vip.webp": 1387,
	"./withdraw-icon.webp": 1388,
	"./wwr-img.webp": 1389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;